import * as React from 'react';
import { Typography } from '../typography';
import { ButtonContentFilter } from '@/components/screens/lawyerapp/client-directory/filters';
import {
	ComboboxMultiple,
	OptionsMultiple,
} from '@/components/ui/comboboxMultiple';
import clsx from 'clsx';

interface HeaderMultipleFilterTableProps {
	title: string;
	searchTitle?: string;
	filterOptions: OptionsMultiple[];
	classNamePopoverContent?: string;
	classNameCommandList?: string;
	classNameCommandGroup?: string;
	hasFilter: boolean;
	containerRef?: (node: HTMLDivElement | null) => void;
	handleSelectFilters: (key: string, value: string | undefined) => void;
	handleClearAll: () => void;
}

export const HeaderMultipleFilterTable: React.FC<
	HeaderMultipleFilterTableProps
> = ({
	title,
	searchTitle,
	filterOptions,
	classNamePopoverContent,
	classNameCommandList,
	classNameCommandGroup,
	hasFilter,
	containerRef,
	handleClearAll,
	handleSelectFilters,
}) => {
	const [open, setOpen] = React.useState<boolean>(false);

	return (
		<div className="flex items-center gap-x-2">
			<Typography
				type="regular-12"
				className="text-opacity-black whitespace-nowrap"
			>
				{title}
			</Typography>
			<ComboboxMultiple
				buttonContent={<ButtonContentFilter active={hasFilter} />}
				title={searchTitle}
				clearAll={() => handleClearAll()}
				open={open}
				placeholder=""
				options={filterOptions}
				value={''}
				setOpen={() => setOpen(!open)}
				classNameCommandList={classNameCommandList}
				classNameCommandGroup={classNameCommandGroup}
				setValue={(key, data) => handleSelectFilters(key, data)}
				classNamePopoverContent={clsx(
					'lg:w-[280px] 2xl:w-[343px]',
					classNamePopoverContent
				)}
				classNameTrigger="!w-fit !bg-transparent"
				typographyTypeLabel="regular-14"
				containerRef={containerRef}
			/>
		</div>
	);
};
